// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"956":"5a458238","5614":"7f6203e6"}[chunkId] + ".chunk.css";
};